import { render, staticRenderFns } from "./DashboardWidgetKatalogbestellungen.vue?vue&type=template&id=24ed2b96&scoped=true"
import script from "./DashboardWidgetKatalogbestellungen.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetKatalogbestellungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed2b96",
  null
  
)

export default component.exports